import React from 'react';
import './About.css';

const About = () => {
  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '50+', label: 'Projects Completed' },
    { number: '100%', label: 'Client Satisfaction' },
    { number: '24/7', label: 'Support Available' }
  ];

  const technologies = [
    'AWS', 'PyTorch', 'TensorFlow', 'Python', 'React', 'Node.js', 
    'Docker', 'Kubernetes', 'PostgreSQL', 'MongoDB', 'Redis', 'Git'
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Us</h2>
            <p className="about-description">
              With over 10 years of experience in software development, Shachar High-Tech Software Development
              has been at the forefront of delivering innovative technology solutions. We 
              specialize in cloud services, machine learning, and data analysis, helping 
              businesses transform their operations through cutting-edge technology.
            </p>
            <p className="about-description">
              Our team combines deep technical expertise with business acumen to deliver 
              solutions that not only meet technical requirements but also drive real 
              business value. We pride ourselves on our commitment to quality, innovation, 
              and client satisfaction.
            </p>
            
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="about-visual">
            <div className="tech-grid">
              {technologies.map((tech, index) => (
                <div key={index} className="tech-item">
                  {tech}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
